import React, { useEffect } from 'react';
import './Helpcentre.css';

const HelpCentre = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const categories = [
    { icon: '🚀', title: 'Getting Started', desc: 'Account opening and first steps' },
    { icon: '💰', title: 'Deposits & Withdrawals', desc: 'Payment methods and processing' },
    { icon: '📊', title: 'Trading Platforms', desc: 'MT4, MT5, and TradingView guides' },
    { icon: '🛡️', title: 'Account Security', desc: '2FA and safety tips' }
  ];

  const faqs = [
    { q: 'How do I open a trading account?', a: 'Click "Open Account" button, fill out the registration form, verify your email, and upload documents.' },
    { q: 'What is the minimum deposit?', a: 'The minimum deposit is $50 for most payment methods and $200 for bank transfers.' },
    { q: 'How long does verification take?', a: 'Account verification typically takes 24-48 hours.' },
    { q: 'Can I have multiple accounts?', a: 'Yes, you can open multiple trading accounts under one client profile.' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Help Centre</h1>
        <p className="subtitle">Find answers to common questions and get the support you need.</p>

        <div className="search-box">
          <span>🔍</span>
          <input type="text" placeholder="Search for help articles..." />
        </div>

        <div className="categories-grid">
          {categories.map((cat, index) => (
            <div key={index} className="category-card">
              <div className="category-icon">{cat.icon}</div>
              <h3>{cat.title}</h3>
              <p>{cat.desc}</p>
            </div>
          ))}
        </div>

        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question">{faq.q}</div>
              <div className="faq-answer">{faq.a}</div>
            </div>
          ))}
        </div>

        <div className="contact-section">
          <h2>Still Need Help?</h2>
          <p>Our support team is available 24/7</p>
          <div className="contact-methods">
            <div>💬 Live Chat</div>
            <div>📧 support@Meta Frx Ai.com</div>
            <div>📞 +1-800-Meta Frx Ai</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCentre;